export default "__VITE_ASSET__BUDG6n9F__"